import './GlobalStyles.scss';

function GlobalStyles(props: any) {
  return props.children;
}
export default GlobalStyles;
